export default __webpack_public_path__ + "static/media/coins-solid.56bc0711.svg";